<template>
  <div>
    <div class="is-hidden-mobile">
      <nav class="navbar container" role="navigation" aria-label="main navigation">
        <div id="navbarBasicExample" class="navbar-menu pd-y-5">
          <div class="navbar-start ">
              <a class="navbar-item fontbold2 is-size-3" >
            <strong>Great</strong><span style="font-weight: initial !important;">Growth</span>
          </a>
          </div>
          <div class="navbar-end has-text-white" :class="$i18n.locale">
            <a href="/file/PresentGreatGrowth.pdf" target="_bank" class="navbar-item is-hover-under-line has-text-white">
              {{$t('nav.overview')}}</a>
            <a href="#keyfeatures"  class="navbar-item is-hover-under-line has-text-white">
              {{$t('nav.keyFeatures')}}</a>
            <a href="signup" class="navbar-item is-hover-under-line has-text-white">
              {{$t('nav.becomeMentor')}}</a>
            <div class="navbar-item">
              <buttons class="buttons">
                <a href="signIn"  class="btn-signin has-text-white has-text-weight-semibold">
                  {{$t('signIn')}}
                </a>
              </buttons>
            </div>
            <div class="navbar-item">
              <b-dropdown v-model="$i18n.locale" aria-role="list">
                <a slot="trigger" :class="$i18n.locale" class="has-text-white flex-middle">
                    <template>
                        <div class="currency-flag mg-r-5" :class="'currency-flag-'+getLocalLanguage($i18n.locale).currency"></div>
                        <span v-if="$i18n.locale === 'th'">{{getLocalLanguage($i18n.locale).nameTh}}</span>
                        <span v-else>{{getLocalLanguage($i18n.locale).nameEn}}</span>
                    </template>
                    <b-icon icon="menu-down"></b-icon>
                </a>

                <b-dropdown-item v-for="item in localLanguage" :value="item.code"  :key="item.code" aria-role="listitem" :class="$i18n.locale" class="itemLanguage">
                    <div class="media">
                        <div class="currency-flag mg-r-5" :class="'currency-flag-'+item.currency"></div>
                        <div class="media-content">
                            <h3>{{($i18n.locale === 'th')?item.nameTh:item.nameEn}}</h3>
                        </div>
                    </div>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </nav>
    </div>
    <div class="is-hidden-tablet">
      <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand pd-t-4" >
          <a class="navbar-item fontbold2 is-size-3 mg-l-5 ">
            <strong>Great</strong><span style="font-weight: initial !important;">Growth  </span>

          </a>
          <a @click="burger = true" role="button" class="navbar-burger burger">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
      </nav>
    </div>
     <div id="navbarBasicExample" class="slide-menu is-hidden-tablet" :class="burger ? 'active':''"  >
        <div class="left-close-menu" @click="burger = false">
          
        </div>
        <div class="navbar-end inside-menu has-text-white" :class="$i18n.locale">
          <ul>
             <li class="has-text-white is-size-4 mg-t-20">
                <span class="has-text-weight-bold">Great</span><span style="font-weight: initial !important;"> Growth  </span> 
                <a @click="burger = false" class="has-text-white is-size-6 close-menu"><i class="fas fa-times"></i></a>
            </li>
            <li>
              <a href="/file/PresentGreatGrowth.pdf" target="_bank" class="has-text-white">
              {{$t('nav.overview')}}</a>
            </li>
            <li>
              <a href="#keyfeatures"  class="has-text-white">
              {{$t('nav.keyFeatures')}}</a>
            </li>
            <li class="">
              <a href="signup" class="has-text-white">
                {{$t('nav.becomeMentor')}}
              </a>
            </li>
            <li>
              <a href="signin"  class="has-text-white" >
                {{$t('signIn')}}
              </a>
            </li>
          </ul>
        </div>
      </div>
</div>
</template>
<script>

export default {
      data() {
            return {
              burger:false

    }
  },
  methods: {
     gopath(val) {
      this.$router.push(val);
    },
  },
  mounted() {

  },
  computed:{
    localLanguage(){
      return this.$store.state.localLanguage
    }
  },
  methods: {
    getLocalLanguage(id){
      let filter = this.localLanguage.filter(filter => filter.code === id)
      if (filter.length > 0) {
        return filter[0]
      }else{
        return {}
      }
    }
  },
};
</script>
<style scoped>

.inside-menu{
  background: #17155A;
  width: 70%;
  height: 100%;
  float: right;
}
.left-close-menu{
  width: 30%;
  height: 100%;
  float: left;
}
.close-menu{
  position: absolute;
  right: 5%;
}
.inside-menu li {
  border-bottom:1px solid #fff;
  padding:15px;
}
.slide-menu.active{
  right: 0;
}
.slide-menu{
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    right: -100%;
    background:rgba(0,0,0,0.6);
    z-index: 40;
    transition:all .4s;
    --webkit-transition: all 0.4s;
}
.navbar-item, .navbar-link{
  padding:0;
}

.navbar-burger{
    color: white;
}
.navbar{
    background-color: transparent;
}
.navbar-end .navbar-item{
padding: 0.5rem 1.75rem;
}
.fontnormal{
  font-size: 14px;
}
.fontbold{
  font-weight: bold;
  font-size: 14px;
  color: white;
  font-size: 14px;
}
.fontbold2{
font-size: 14px;
color: white;
}
.btn-signin{
  padding:5px 25px;
  border:1px solid #fff;
  background: transparent ;
  border-radius: 40px;
  display: inline-block;
  transition: all 0.3s;
  --webkit-transition: all 0.3s;
}
.btn-signin:hover{
  border:1px solid #0D6ACA;
  color: #0D6ACA!important;
}

.display-b{
  display: block!important;
  background-color:unset;
}
.itemLanguage.is-active{
  background-color: #0D6ACA;
}
</style>